import { bootstrapApplication } from '@angular/platform-browser';
import { Environment, loadEnvironment } from '@shared/utils';
import { AppComponent } from './app/app.component';
import { createApplicationConfig } from './app/app.config';

/** Build konfigurace `development-cas` (project.json, `define`): lokální přihlášení přes CAS místo vývojového tokenu. */
declare const REZA_LOCAL_CAS: boolean | undefined;

function injectChatbot(env: Environment): void {
  if (!env.chatbotUrl) return;
  const base = env.chatbotUrl.endsWith('/') ? env.chatbotUrl : `${env.chatbotUrl}/`;
  const script = document.createElement('script');
  script.src = `${base}chat-embed.js`;
  script.dataset['appUrl'] = base;
  script.dataset['buttonImage'] = `${base}avatarDia.png`;
  script.dataset['autoEnable'] = 'false';
  script.onload = () => (window as Window & { initChat?: () => void }).initChat?.();
  document.head.appendChild(script);
}

loadEnvironment()
  .then((loaded) => {
    const envJson: Environment =
      typeof REZA_LOCAL_CAS !== 'undefined' && REZA_LOCAL_CAS ? { ...loaded, localAuth: 'cas' } : loaded;
    injectChatbot(envJson);
    bootstrapApplication(AppComponent, createApplicationConfig(envJson)).catch((err) =>
      console.error('Bootstrap error:', err)
    );
  })
  .catch((error) => {
    console.error('Error loading configuration:', error);
  });
